<w-content-list [showHeader]="false">
  @for (item of $displayFiles(); track item.fileId) {
    <w-list-item [icon]="item.icon" [header]="item.filename" [description]="item.description" [command]="item.command" />
  }
</w-content-list>
